import React from 'react';

// Fuente única (Res. MinTIC 1519/2020): canales de atención en el portal de ICETEX.
const CANALES_URL = 'https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania/canales-de-atencion/canales-digitales';

const ResourcesAdditional = () => {
  return (
    <div
      className="grid gap-[30px] mb-[60px]"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))' }}
    >
      {/* Help Lines Card */}
      <div
        className="bg-white rounded-[20px] p-[40px] border-l-[5px] border-icetex"
        style={{ boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)' }}
      >
        <div
          className="flex items-center justify-center rounded-[15px] mb-5 w-[60px] h-[60px] bg-gradient-to-br from-icetex to-icetex-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-white"
            style={{ width: '30px', height: '30px' }}
          >
            <path d="M12 20h9"></path>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
          </svg>
        </div>
        <h3 className="text-texto-oscuro font-bold mb-[15px] text-[1.5rem]">
          Líneas de Ayuda en Colombia
        </h3>
        <p className="text-texto-sec mb-5 text-[1rem] leading-[1.7]">
          Si necesitas apoyo inmediato, recuerda que en Colombia existen varias líneas de ayuda
          disponibles 24/7 para brindarte orientación y soporte emocional:
        </p>
        <ul className="list-none p-0 mt-5">
          {[
            { num: 'Línea 106', desc: 'Línea Nacional de Orientación en Salud Mental (24 horas)' },
            { num: 'Línea 141', desc: 'Instituto Colombiano de Bienestar Familiar - ICBF' },
            { num: 'Línea 155', desc: 'Línea de orientación a mujeres víctimas de violencia' },
            { num: 'Línea 123', desc: 'Emergencias (Policía, bomberos, salud)' },
          ].map((item, idx, arr) => (
            <li
              key={item.num}
              className="text-texto-sec"
              style={{
                padding: '12px 0',
                borderBottom: idx < arr.length - 1 ? '1px solid #e8f0fe' : 'none',
                fontSize: '0.95rem',
                lineHeight: '1.6',
              }}
            >
              <strong className="text-icetex font-bold">{item.num}:</strong> {item.desc}
            </li>
          ))}
        </ul>
      </div>

      {/* More Resources Card */}
      <div
        className="bg-white rounded-[20px] p-[40px] border-l-[5px] border-icetex"
        style={{ boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)' }}
      >
        <div
          className="flex items-center justify-center rounded-[15px] mb-5 w-[60px] h-[60px] bg-gradient-to-br from-icetex to-icetex-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-white"
            style={{ width: '30px', height: '30px' }}
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <h3 className="text-texto-oscuro font-bold mb-[15px] text-[1.5rem]">
          ¿Necesitas Más Recursos?
        </h3>
        <p className="text-texto-sec mb-5 text-[1rem] leading-[1.7]">
          Estamos constantemente actualizando nuestra biblioteca de recursos. Si necesitas
          materiales adicionales o tienes sugerencias sobre qué contenido te gustaría ver,
          no dudes en contactarnos.
        </p>
        <a
          href={CANALES_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-icetex font-bold no-underline mt-[10px] hover:text-icetex-dark hover:translate-x-1 transition-all duration-300"
        >
          Contáctanos →
        </a>
      </div>
    </div>
  );
};

export default ResourcesAdditional;
